import React from 'react';
import classnames from 'classnames';
import { Container, Row, Col } from 'react-bootstrap';
import FooterNavigation from '../FooterNavigation';
import FooterDownloadApp from '../FooterDownloadApp';
import { Props } from './Footer.models';
import { INIT_PROPS } from './Footer.constants';
import styles from './Footer.module.scss';

export default class Footer extends React.Component<Props> {
  static defaultProps: Props = INIT_PROPS;
  render() {
    const { className: wrapperClass } = this.props;
    return (
      <div className={classnames([styles.wrapper, wrapperClass])}>
        <Container>
        <Row>
          <Col>
            <FooterDownloadApp />
          </Col>
          <Col xs="12" sm="auto">
            <FooterNavigation />
          </Col>
        </Row>
        </Container>
      </div>
    )
  }
}
